angular.module('dpw.filters')
    .filter('pagesArr', [function () {
        return function (totalPages) {
            var arr = [];
            for (var i = 1; i <= totalPages; i++) {
                arr.push(i);
            }
            return arr;
        };
    }])
    .filter('join', [function () {
        return function (arr, delimitor) {
            return arr.join(delimitor);
        };
    }])
    .filter('prefixPlus', [function () {
        var plusSign = '+';
        var maxShortNumberLength = 5;

        function handlePlus(value) {
            if ((!_.startsWith(value, plusSign)) && _.size(value) > maxShortNumberLength) {
                value = plusSign + value;
            }
            return value;
        }

        return function (value) {
            return value ? handlePlus(value) : 'Pending';
        };
    }])
    .filter('adminDefaultExt', [function () {
        return function (brandId) {
            var extConfig = {
                3710: '301',
                7710: '301',
                2010: '301'
            };

            return extConfig[brandId] || '101';
        };
    }])
    .filter('decodeEntities', ['$sce', 'helpers', function ($sce, helpers) {
        return function (content) {
            if (!angular.isString(content)) {
                return content;
            }
            content = helpers.decodeEntities(content);

            return $sce.trustAsHtml(content);
        };
    }])
    .filter('removeImageTags', ['$sce', function ($sce) {
        return function (content) {
            if (content) {
                content = angular.isString(content) ? content : content.toString();
                content = content.replace(/<img(.)*?[\/]?>/g, '');
            }

            return $sce.trustAsHtml(content);
        };
    }])
    .filter('brandDisplayName', ['brands', function (brands) {
        return function (brandId) {
            return brands[brandId];
        };
    }])
    .filter('brandDisplayNameForAppGallery', ['brandsForAppGallery', function (brandsForAppGallery) {
        return function (brandId) {
            return brandsForAppGallery[brandId];
        };
    }])
    .filter('formatPostDate', [function () {
        return function (dateString) {
            return angular.isString(dateString) ?
                dateString.split(' ').join('T') :
                dateString;
        };
    }])
    .filter('trustAsResourceUrl', ['$sce', function ($sce) {
        return function (val) {
            return $sce.trustAsResourceUrl(val);
        };
    }])
    .filter('dpwMailTo', ['$sce', function ($sce) {
        return function (email) {
            var mailtoLink = '<a href="mailto:' + email + '">' + email + '</a>';
            return $sce.trustAsHtml(email ? mailtoLink : '');
        };
    }])
    .filter('consoleDateTime', ['$filter', function ($filter) {

        function filter(value) {
            return $filter('date')(value, 'medium');
        }

        filter.$stateful = true;
        return filter;

    }])
    .filter('ignoreInvalidTime', ['UNIXStartTime', function (UNIXStartTime) {
        return function (value) {
            return moment(value) > UNIXStartTime ? value : '';
        };
    }])
    .filter('orgName', [function () {
        return function (value) {
            return value ? value : '<Empty>';
        };
    }])
    .filter('usagePlanTimeframe', [function () {
        return function (value) {
            return (value <= 60 ? [value, 'seconds'] : [value / 60, 'minutes']).join(' ');
        };
    }])
    .filter('initiatorLabelFormatter', [function () {
        return function (initiator, type) {
            var isAdminRole = (initiator.role === 'Admin');
            return isAdminRole ? formatAdminName() : formatUserName();

            function formatAdminName() {
                if (type !== 'admin') {
                    return 'Admin';
                }
                var principleName = initiator.id || '';
                return (principleName === 'admin') ? 'RC System' : _.first(principleName.split('@'));
            }

            function formatUserName() {
                return _.trim(initiator.name);
            }
        };
    }])
    .filter('initiatorFormatter', ['$sce', 'initiatorLabelFormatterFilter', function ($sce, initiatorLabelFormatterFilter) {
        return function (list) {
            list = list || [];
            list.forEach(function (record) {
                ['application', 'organization', 'key', 'app-profile'].forEach(function (type) {
                    record[type] = _.find(record.objects, {type: type});
                });
            });
            return list.map(function (item) {
                var initiator = item.initiator;
                initiator.type = initiator.role;
                initiator.label = _.escape(initiatorLabelFormatterFilter(item.initiator, 'admin'));

                if (initiator.role === 'Admin' && initiator.id !== 'admin') {
                    initiator.type = 'RCAdmin';
                    initiator.label = $sce.trustAsHtml(
                        initiator.label +
                        '<br>' +
                        RCDPW.Lang.Administration.APP_HISTORY_INITIATOR_RC_ADMIN
                    );
                }

                if (initiator.role === 'User' && (_.isEmpty(initiator.label) || initiator.label === 'Deleted')) {
                    initiator.type = 'UserWithoutLink';
                    initiator.label = RCDPW.Lang.Administration.APP_HISTORY_INITIATOR_PLACEHOLDER;
                }

                return item;
            });
        };
    }])
    .filter('platformType', ['$filter', 'platformTypes', 'deprecatedPlatformTypes',
        function ($filter, platformTypes, deprecatedPlatformTypes) {
            var allPlatformTypes = platformTypes.concat(deprecatedPlatformTypes);
            var platformMap = {};
            angular.forEach(allPlatformTypes, function (item) {
                platformMap[item.id] = item.text;
            });
            return function (value) {
                return platformMap[value] || '';
            };
        }
    ])
    .filter('consoleDate', ['$filter', function ($filter) {
        function filter(value) {
            return $filter('date')(value, 'mediumDate');
        }

        filter.$stateful = true;
        return filter;
    }])
    .filter('grantType', [function () {
        var grantTypeAliasMap = {
            'Resource Owner Password Credentials': 'Password flow'
        };

        return function (grantTypeName) {
            return _.get(grantTypeAliasMap, grantTypeName, grantTypeName);
        };
    }])
    .filter('truncatLongText', [function () {
        return function (input, len) {
            if (!input) {
                return '';
            }
            return input.length > len ? (input.substring(0, len) + '...') : input;
        };
    }])
    .filter('splitByNewLine', [function () {
        return function (input) {
            input = input || '';
            return /\r\n/.test(input) ? input.split(/\r\n/) : input.split(/\n/);
        };
    }])
    .filter('appGalleryCategoryItem', ['appProfileConstants', function (appProfileConstants) {
        return function (input, type) {
            if (_.isArray(input)) {
                input = removeInvalidItem(input);
                return input.join(', ');
            } else if (_.isString(input)) {
                input = input.split(';');
                input = removeInvalidItem(input);
                return input.join(', ');
            } else {
                return input;
            }

            function removeInvalidItem(items) {
                return items.filter(function (item) {
                    return _.includes(appProfileConstants[type], item);
                });
            }
        };
    }])
    .filter('XSRFProtect', ['$cookies', function ($cookies) {
        return function (input) {
            var XSRF_TOKEN = $cookies.get('XSRF-TOKEN');

            if (!_.isString(input) || !XSRF_TOKEN) {
                return input;
            }

            var XSRF_QUERY = 'sctk=' + XSRF_TOKEN;
            var queryPrefix = _.includes(input, '?') ? '&' : '?';

            return input + queryPrefix + XSRF_QUERY;
        };
    }])
    .filter('linkyOrMd', ['$filter', 'appProfileUtils', 'markdownUtils', 'helpers', function ($filter, appProfileUtils, markdownUtils, helpers) {

        return function (input) {
            var textFormat = appProfileUtils.textFormatUtils.detectFormat(input);
            if (textFormat.text) {
                if (textFormat.format === appProfileUtils.textFormatUtils.formatConfig.markdown.id) {
                    return markdownUtils.md2Html(textFormat.text);
                } else {
                    return $filter('linky')(textFormat.text, '_blank', helpers.getFormattedLinkAttrs);
                }
            }

        };
    }]);
